/* ML – Homepage showstopper (v4): viewport width var, hero offset, scroll reveals, product rail arrows. */
(function(){
  if(window.__mlhInit)return;window.__mlhInit=true;
  var d=document,de=d.documentElement,rm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var design=window.Shopify&&window.Shopify.designMode;
  function vw(){de.style.setProperty('--mlh-vw',de.clientWidth+'px');}
  function heroTop(){d.querySelectorAll('[data-mlh-hero]').forEach(function(h){
    var t=h.getBoundingClientRect().top+window.scrollY;h.style.setProperty('--mlh-top',(t>0&&t<420?Math.round(t):0)+'px');});}
  var io=null;
  function reveal(root){
    var els=(root||d).querySelectorAll('.mlh [data-mlh-reveal]:not(.is-in)');
    if(!io){els.forEach(function(e){e.classList.add('is-in');});return;}
    els.forEach(function(e){io.observe(e);});
  }
  function rails(root){(root||d).querySelectorAll('[data-mlh-rail]').forEach(function(s){
    if(s.__mlh)return;s.__mlh=1;var r=s.querySelector('.mlh-row'),b=s.querySelectorAll('.mlh-arrow');if(!r||b.length<2)return;
    function u(){b[0].disabled=r.scrollLeft<4;b[1].disabled=r.scrollLeft+r.clientWidth>=r.scrollWidth-4;}
    b.forEach(function(x){x.addEventListener('click',function(){r.scrollBy({left:+x.dataset.dir*r.clientWidth*.9,behavior:rm.matches?'auto':'smooth'});});});
    r.addEventListener('scroll',u,{passive:true});window.addEventListener('resize',u);u();});}
  function init(root){vw();heroTop();rails(root);reveal(root);}
  if('IntersectionObserver' in window&&!rm.matches&&!design){
    de.classList.add('mlh-js');
    io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}});},{rootMargin:'0px 0px -8% 0px',threshold:.08});
  }
  if(d.readyState==='loading')d.addEventListener('DOMContentLoaded',function(){init();});else init();
  window.addEventListener('resize',function(){vw();heroTop();},{passive:true});
  window.addEventListener('load',heroTop);
  d.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
